import React from 'react';
import Login from './Login';

const AuthPage: React.FC = () => {
  return <Login />;
};

export default AuthPage;